<template>
  <div>

    <VueLoading :isLoading="isLoading" :key="isLoading" />
    <div :class="view_class_view.div_container_1.conatiner">
      <div :class="view_class_view.div_container_1.div_work_status">
        <ChooseButton
          ref="refWorkStatus"
          :buttons="buttonsWorkStatus"
          v-on:choose-button="changeLaboralStatus($event)"
          label="Estatus:"
          :containerClass="
            view_class_view.div_container_1.choose_button_class.container
          "
          :buttonClass="
            view_class_view.div_container_1.choose_button_class.button_class
          "
          :selectFirstButton="true"
          :buttons_styles="buttons_styles"
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .typeOfWork.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_1.div_work_type"
        v-show="form_visibility.type_work"
      >
        <ChooseButton
          ref="workOfTypeRef"
          :key="buttonsWorkTypeKey"
          :buttons="buttonsWorkType"
          v-on:choose-button="changeWorkType($event)"
          label="Tipo de trabajo:"
          :containerClass="
            view_class_view.div_container_1.choose_button_class.container
          "
          :buttonClass="
            view_class_view.div_container_1.choose_button_class.button_class
          "
          :selectFirstButton="true"
          :buttons_styles="buttons_styles"
        />
      </div>
    </div>

    <div :class="view_class_view.div_container_2.conatiner">
      <!-- Option 1 -->
      <div
        :class="view_class_view.div_container_2.rotation_working"
        v-show="form_visibility.business_rotation"
      >
        <label for="select_business_rotation_working_information"
          >Giro Empresarial:</label
        >
        <select :disabled="selectBusinessWorkInfo.disabled" id="select_business_rotation_working_information"
          @change="show_form_pension()"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workCenter.businessLine
                .$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workCenter.businessLine
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workCenter.businessLine
                .$invalid &&
              !laborInformationModelValidation.work.workCenter.businessLine
                .$error,
          }"
          @blur="
            laborInformationModelValidation.work.workCenter.businessLine
              .$validate
          "
          v-model="laborInformation.work.workCenter.businessLine"
        >
          <option value="" selected disabled>
            Seleccione un giro empresarial
          </option>
          <option
            v-for="businessActivity in listBusinessActivities"
            :value="businessActivity.name"
            :key="businessActivity.id"
          >
            {{ businessActivity.name }}
          </option>
        </select>

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .workCenter.businessLine.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_2.place_working_information"
        v-show="form_visibility.work_place"
      >
        <label for="Select_work_place_working_information"
          >Lugar de Trabajo:
        </label>
        <select
          id="Select_work_place_working_information"
          v-model="laborInformation.work.workCenter.workCenter"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workCenter.workCenter.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workCenter.workCenter
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workCenter.workCenter
                .$invalid &&
              !laborInformationModelValidation.work.workCenter.workCenter
                .$error,
          }"
          @blur="
            laborInformationModelValidation.work.workCenter.workCenter.$validate
          "
        >
          <option value="" selected disabled>
            Seleccione un lugar de trabajo
          </option>
          <option
            v-for="affiliated in listAffiliatedBusiness"
            :key="affiliated.id"
            :value="affiliated.acronym"
          >
            {{ affiliated.name }}
          </option>
          <option value="OTRO">Otros...</option>
        </select>

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .workCenter.workCenter.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
      <!-- Option 1 finish -->

      
      <!-- Option 2  -->
      <div
        :class="view_class_view.div_container_2.business_name_working"
        v-show="form_visibility.business_name"
      >
        <label for="input_business_name_working_information">
          Nombre del Negocio:</label
        >
        <input
          id="input_business_name_working_information"
          type="text"
          v-model="laborInformation.work.workName"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workName.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workName.$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workName.$invalid &&
              !laborInformationModelValidation.work.workName.$error,
          }"
          @blur="laborInformationModelValidation.work.workName.$validate"
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work.workName
            .$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
      <!-- Option 2 finish  -->

      <!-- Option 3 -->
      <div
        :class="view_class_view.div_container_2.union_section"
        v-show="form_visibility.union_section"
      >
        <label for="select_union_section">Sección Sindical:</label>
        <select
          id="select_union_section"
          v-model="laborInformation.work.workCenter.unionSection"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workCenter.unionSection
                .$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workCenter.unionSection
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workCenter.unionSection
                .$invalid &&
              !laborInformationModelValidation.work.workCenter.unionSection
                .$error,
          }"
          @blur="
            laborInformationModelValidation.work.workCenter.unionSection
              .$validate
          "
        >
          <option
            v-for="unionSections in listUnionSections"
            :key="unionSections.id"
            :value="`${unionSections.section} ${unionSections.acronym}`"
          >
            {{ unionSections.section.toString().toUpperCase() }}
            {{ unionSections.acronym.toString().toUpperCase() }}
          </option>
        </select>

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .workCenter.unionSection.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
       <!-- Option 3 finish -->



      <div
        :class="view_class_view.div_container_2.additional_data"
        v-show="form_visibility.additional_data"
      >
        <label for="Select_work_place_additional_data">Dependencias:</label>
        <select id="Select_work_place_additional_data"
          v-model="laborInformation.work.workCenter.additional_data"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workCenter.additional_data.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workCenter.additional_data
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workCenter.additional_data
                .$invalid &&
              !laborInformationModelValidation.work.workCenter.additional_data
                .$error,
          }"
          @blur="
            laborInformationModelValidation.work.workCenter.additional_data.$validate
          "
        >
        <option value="" disabled selected> Seleccione una opción</option>
          <option v-for="(dependencie,index) in dependecies" :key="dependencie.id+'_'+index" :value="dependencie.value">
            {{ dependencie.name }}
          </option>

        </select>

        <div :class="view_class_view.div_container_error.container" v-for="(error, index) of laborInformationModelValidation.work.workCenter.additional_data.$errors" :key="index">
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
      
      
     

      <!-- Option 4 -->
      <div
        :class="view_class_view.div_container_2.workplace_name_working"
        v-show="form_visibility.workplace_name_working"
      >
        <label for="input_workplace_name_working_information"
          >Nombre del Centro de trabajo:</label
        >
        <input
          id="input_workplace_name_working_information"
          type="text"
          v-model="laborInformation.work.workCenter.workCenterName"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.workCenter.workCenterName
                .$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.workCenter.workCenterName
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.workCenter.workCenterName
                .$invalid &&
              !laborInformationModelValidation.work.workCenter.workCenterName
                .$error,
          }"
          @blur="
            laborInformationModelValidation.work.workCenter.workCenterName
              .$validate
          "
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .workCenter.workCenterName.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
      <!-- Option 4 finish -->

      <div
        :class="view_class_view.div_container_2.workplace_working"
        v-show="form_visibility.workplace_working"
      >
        <label for="input_workplace_working_information">
          Centro de trabajo:</label
        >
        <input
          id="input_workplace_working_information"
          type="text"
          v-model="laborInformation.work.freeWorkCenterName"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.work.freeWorkCenterName.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.work.freeWorkCenterName.$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.work.freeWorkCenterName
                .$invalid &&
              !laborInformationModelValidation.work.freeWorkCenterName.$error,
          }"
          @blur="
            laborInformationModelValidation.work.freeWorkCenterName.$validate
          "
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.work
            .freeWorkCenterName.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div v-show="form_visibility.address" class="col-span-12">
        <AddressComponent ref="addressRef" :view_class_view="viewClassViewAddress" :validations="rulesValidationsAddress" />
      </div>
    </div>

    <div
      :class="view_class_view.div_container_5.conatiner"
      v-show="form_visibility.contact"
    >
      <div :class="view_class_view.div_container_5.phone_working_information">
        <label for="input_phone_working_information">Teléfono:</label>
        <input
          id="input_phone_working_information"
          type="text"
          v-model="laborInformation.telephone.number"
          inputmode="tel"
          v-maska="'### ###-####'"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.telephone.number.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.telephone.number.$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.telephone.number.$invalid &&
              !laborInformationModelValidation.telephone.number.$error,
          }"
          @blur="laborInformationModelValidation.telephone.number.$validate"
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.telephone
            .number.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div :class="view_class_view.div_container_5.phone_extension">
        <label for="input_phone_extension_working_information"
          >Extensión:</label
        >
        <input
          id="input_phone_extension_working_information"
          type="text"
          v-model="laborInformation.telephone.lada"
          inputmode="tel"
          v-maska="'####'"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.telephone.lada.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.telephone.lada.$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.telephone.lada.$invalid &&
              !laborInformationModelValidation.telephone.lada.$error,
          }"
          @blur="laborInformationModelValidation.telephone.lada.$validate"
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.telephone
            .lada.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>

    <div :class="view_class_view.div_container_3.conatiner">
      <div :class="view_class_view.div_container_3.retired">
        <ChooseButton
          ref="refPublicCharge"
          :key="buttonsPublicCharge"
          :buttons="buttonsPublicCharge"
          v-on:choose-button="changePublicCharge($event)"
          label="¿Ha tenido algún cargo público?"
          :containerClass="
            view_class_view.div_container_3.choose_button_class.container
          "
          :buttonClass="
            view_class_view.div_container_3.choose_button_class.button_class
          "
          v-model="laborInformation.publicCharge.endDate"
          :buttons_styles="buttons_styles"
        />
      </div>

      <div
        :class="view_class_view.div_container_3.publicCharge"
        v-show="form_visibility.publicCharge"
      >
        <label for="button_mexico_birthplace"
          >¿Qué cargo público ha desempeñado?</label
        >
        <input
          id="input_public_office_owner"
          type="text"
          v-model="laborInformation.publicCharge.questionTwo"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.publicCharge.questionTwo.$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.publicCharge.questionTwo
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.publicCharge.questionTwo
                .$invalid &&
              !laborInformationModelValidation.publicCharge.questionTwo.$error,
          }"
          @blur="
            laborInformationModelValidation.publicCharge.questionTwo.$validate
          "
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.publicCharge
            .questionTwo.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_3.publicCharge"
        v-show="form_visibility.publicCharge"
      >
        <label for="button_mexico_birthplace"> De: </label>
        <DatePicker
          editable
          v-model="laborInformation.publicCharge.startDate"
          @change="select_date($event, 'publicCharge', 'startDate')"
          format="DD/MM/YYYY"
          simple
          locale="es"
          :localeConfig="{
            es: {
              displayFormat: 'DD/MM/YYYY',
              lang: {
                year: 'Año',
                month: 'Mes',
                day: 'Día',
                label: '',
                submit: 'Seleccionar',
                cancel: 'Cancelar',
                now: 'Hoy',
                nextMonth: 'Siguiente',
                prevMonth: 'Anterior',
              },
            },
          }"
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.publicCharge
            .startDate.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_3.publicCharge"
        v-show="form_visibility.publicCharge"
      >
        <label for="button_mexico_birthplace"> A: </label>
        <DatePicker
          editable
          format="DD/MM/YYYY"
          simple
          v-model="laborInformation.publicCharge.endDate"
          @change="select_date($event, 'publicCharge', 'endDate')"
          locale="es"
          :localeConfig="{
            es: {
              displayFormat: 'DD/MM/YYYY',
              lang: {
                year: 'Año',
                month: 'Mes',
                day: 'Día',
                label: '',
                submit: 'Seleccionar',
                cancel: 'Cancelar',
                now: 'Hoy',
                nextMonth: 'Siguiente',
                prevMonth: 'Anterior',
              },
            },
          }"
        />
        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation.publicCharge
            .endDate.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>

    <div :class="view_class_view.div_container_4.conatiner">
      <div :class="view_class_view.div_container_4.retired">
        <ChooseButton
        ref="refFamilyPublicCharge"
          :buttons="buttonsFamilyPublicCharge"
          v-on:choose-button="changeFamilyPublicCharge($event)"
          label="¿Algún familiar ha tenido cargo público? (Cónyuge, Hijo(a), Padre/Madre, Hermano, Concubino(a))"
          :containerClass="
            view_class_view.div_container_4.choose_button_class.container
          "
          :buttonClass="
            view_class_view.div_container_4.choose_button_class.button_class
          "
          :buttons_styles="buttons_styles"
        />
      </div>

      <div
        :class="view_class_view.div_container_4.public_office_owner"
        v-show="form_visibility.publicChargeFamily"
      >
        <label for="input_public_office_owner"
          >¿Qué cargo público ha desempeñado?
        </label>
        <input
          id="input_public_office_owner"
          type="text"
          v-model="laborInformation.publicChargeFamily.questionTwo"
          v-bind:class="{
            [view_class_view.classInputs.default +
            view_class_view.classInputs.no_valid]:
              laborInformationModelValidation.publicChargeFamily.questionTwo
                .$error,
            [view_class_view.classInputs.default +
            view_class_view.classInputs.valid]:
              !laborInformationModelValidation.publicChargeFamily.questionTwo
                .$invalid,
            [view_class_view.classInputs.default]:
              laborInformationModelValidation.publicChargeFamily.questionTwo
                .$invalid &&
              !laborInformationModelValidation.publicChargeFamily.questionTwo
                .$error,
          }"
          @blur="
            laborInformationModelValidation.publicChargeFamily.questionTwo
              .$validate
          "
        />

        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation
            .publicChargeFamily.questionTwo.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_4.public_office_date_start"
        v-show="form_visibility.publicChargeFamily"
      >
        <label>De:</label>
        <DatePicker
          editable
          format="DD/MM/YYYY"
          v-model="laborInformation.publicChargeFamily.startDate"
          @change="select_date($event, 'publicChargeFamily', 'startDate')"
          simple
          locale="es"
          :localeConfig="{
            es: {
              displayFormat: 'DD/MM/YYYY',
              lang: {
                year: 'Año',
                month: 'Mes',
                day: 'Día',
                label: '',
                submit: 'Seleccionar',
                cancel: 'Cancelar',
                now: 'Hoy',
                nextMonth: 'Siguiente',
                prevMonth: 'Anterior',
              },
            },
          }"
        />
        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation
            .publicChargeFamily.startDate.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>

      <div
        :class="view_class_view.div_container_4.public_office_date_end"
        v-show="form_visibility.publicChargeFamily"
      >
        <label>A:</label>
        <DatePicker
          editable
          format="DD/MM/YYYY"
          v-model="laborInformation.publicChargeFamily.endDate"
          @change="select_date($event, 'publicChargeFamily', 'endDate')"
          simple
          locale="es"
          :localeConfig="{
            es: {
              displayFormat: 'DD/MM/YYYY',
              lang: {
                year: 'Año',
                month: 'Mes',
                day: 'Día',
                label: '',
                submit: 'Seleccionar',
                cancel: 'Cancelar',
                now: 'Hoy',
                nextMonth: 'Siguiente',
                prevMonth: 'Anterior',
              },
            },
          }"
        />
        <div
          :class="view_class_view.div_container_error.container"
          v-for="(error, index) of laborInformationModelValidation
            .publicChargeFamily.endDate.$errors"
          :key="index"
        >
          <div :class="view_class_view.div_container_error.text_error">
            {{ error.$message }}
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import ChooseButton from "./Forms/ChooseButton.vue";
import AddressComponent from "./Address.vue";
import { helpers, requiredIf, minLength, maxLength} from "@vuelidate/validators";

import VueLoading from "./VueLoading.vue";
import { onMounted, onBeforeMount, ref, watch } from "vue";
import axios from "axios";
import useVuelidate from "@vuelidate/core";
import moment from "moment";

export default {
  name: "WorkingInformationComponent",
  components: {
    ChooseButton,
    VueLoading,
    AddressComponent
  },
  props: {
    buttons_styles:{},
    selectBusinessWorkInfo: {
      type: Object,
      default(){
          return {
              disabled: false,
              default_value: '' 
          }
      }
    },
    validations: {},
    urlAPI: {},
    key_toke_storage: {},
    view_class_view: {},
    active_job_type_options: {
      type: Object,
      default() {
        return {
          button_employee_status_working_information: true,
          button_own_businesss_working_information: true,
          button_education_worker_working_information: true,
          button_health_worker_working_information: true,
        };
      },
    },
    active_job_status: {
      type: Object,
      default() {
        return {
          button_active_status_working_information: true,
          button_retired_status_working_information: true,
          button_student_status_working_information: true,
        };
      },
    },
    business: {
      type: String,
      default(){
        return ""
      }
    },
    props_form_visibility:{
      type: Object,
      default() {
        return {
          work_place: false,
        };
      }
    }
  },
  setup(props) {
    const refPublicCharge = ref(null);
    const refFamilyPublicCharge = ref(null);
    const refWorkStatus = ref(null);
    onBeforeMount(() => {
      showActiveOptions();
    });

    onMounted(() => {
      get_catalog_business_activities();
      get_affiliated_business();
      get_catalog_union_sections();
    });

    const dependecies = ref(
      [
        { value:"D",id:"d_dependencie", name:"D Jubilados homologados Centralizados" },
        { value:"I",id:"i_dependencie", name:"I Preescolar, primaria, niveles especiales, secunadria, UPN, Normales" },
        { value:"S",id:"s_dependencie", name:"S Lazaro Cardenas, Tecnoloíco, SEIT(CBTIS,SESITIS;CBTA,BRIGADAS) CECATIS, Representación SEP" },
        { value:"J",id:"j_dependencie", name:"J Jubilados ISEP" }
      ]
    );

    const isLoading = ref(false);
    const addressRef = ref(null);
    const workOfTypeRef = ref(null);

    let listBusinessActivities = ref([]);
    let listAffiliatedBusiness = ref([]);
    let listUnionSections = ref([]);
    let laborInformation = ref({
      work: {
        workStatus: true,
        typeOfWork: "Empleado",
        workName: "",
        freeWorkCenterName: "",
        workCenter: {
          businessLine: "",
          workCenter: "",
          workCenterName: "",
          unionSection: "",
          additional_data:""
        },
      },
      telephone: {
        number: "",
        lada: "",
      },
      publicCharge: {
        questionOne: false,
        questionTwo: "",
        startDate: "",
        endDate: "",
      },
      publicChargeFamily: {
        questionOne: false,
        questionTwo: "",
        startDate: "",
        endDate: "",
      },
    });

    let laborInformationModelValidation = useVuelidate(
      props.validations,
      laborInformation
    );

    let viewClassViewAddress = {
      classInputs:{
        valid:"border-blue-600",
        no_valid:"border-red-600",
        default:"w-full py-2 px-2 rounded-md border-2 border-sm focus:border-blue-600 mb-2 mt-2 shadow-md focus:outline-none "
      },
      div_container_error:{
        container:"my-2",
        text_error:"text-red-600",
      },
      div_container_1 : {
        container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10",
        input_class:"",
        div_container_neightboorhood:{
          container:"mt-5 sm:mt-0"
        },
      },
      div_container_2 : {
        container:"grid grid-cols-1 sm:grid-cols-3 sm:gap-10 mt-5 ",
        state:{
          label : "label-input w-full block tracking-wide mb-2 mt-5",
          label_information: "label-input w-full block tracking-wide mb-2 text-2xl mt-5",
        },
        municipality:{
          label : "label-input w-full block tracking-wide mb-2 mt-5",
          label_information: "label-input w-full block tracking-wide mb-2 text-2xl mt-5",
        },
        city_address:{
          label : "label-input w-full block tracking-wide mb-2 mt-5",
          label_information: "label-input w-full block tracking-wide mb-2 text-2xl mt-5",
        }
      },
      div_container_3 : {
        container:"grid grid-cols-1 sm:grid-cols-4 sm:gap-10 ",
        div_container_street:{
          container:"sm:col-span-2 mt-5"
        },
        div_container_exterior_street:{
          container:"mt-5"
        },
        div_container_interior_street:{
          container:"mt-5"
        }
      },
      div_container_4 : {
        container:"grid grid-cols-1 sm:grid-cols-4 sm:gap-10 mb-8",
        div_container_between_street_address:{
          container:"mt-5"
        },
        div_and_street_address:{
          container:"mt-5"
        }
      }
    };

    let rulesValidationsAddress = {
      street: {
        required:helpers.withMessage("El campo es requerido.", requiredIf(function(){
          return (laborInformation.value.work.workStatus == true || laborInformation.value.work.workStatus == false || laborInformation.value.work.workStatus == null)? false: true;
        })),
        minLength: helpers.withMessage("El campo debe contener mínimo 2 caracteres", minLength(2)),
        maxLength: helpers.withMessage("El campo debe contener máximo 100 caracteres", maxLength(100)),
        isAlphaNumeric:helpers.withMessage(`El campo no admite caracteres especiales.`,(data,index)=>index.street != ""? !new RegExp(/[^0-9a-zA-ZÀ-ÿ\s-#]+/).test(index.street): true),
        we_have_space_white_start_and_finish:helpers.withMessage(`El campo no puede tener espacios en blanco al inicio y al final.`,(data,index)=>index.street != ""? !new RegExp(/^([\s]{1,})|[-!$%^&*()_+|~=`{}[]:";'<>?,.\/]|([\s]{1,})$/).test(index.street): true),
        street_one_and_street_two_equal_street: helpers.withMessage(`El valor de: "Calle" no pueden ser igual a "Entre Calle" o "Y Calle"`, (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          return ![index.between_street_one,index.between_street_two].includes(index.street)
        })
      },
      suburb: {
        required:helpers.withMessage("El campo es requerido.", requiredIf(function(){
          return (laborInformation.value.work.workStatus)? true: false;
        }))
      },
      ext_number: {
        required:helpers.withMessage("El campo es requerido.", requiredIf(function(){
          return (laborInformation.value.work.workStatus)? true: false;
        })),
        minLength: helpers.withMessage("El campo debe contener mínimo 1 caracter", minLength(1)),
        maxLength: helpers.withMessage("El campo debe contener máximo 5 caracteres", maxLength(5)),
        onlyNumber: helpers.withMessage("El campo solo acepta números.", (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          return (new RegExp('^[0-9]+$')).test(index.ext_number)
        })
      },
      int_number: {
        minLength: helpers.withMessage("El campo debe contener mínimo 1 caracter", minLength(1)),
        maxLength: helpers.withMessage("El campo debe contener máximo 5 caracteres", maxLength(5)),
        onlyNumberAndLetter: helpers.withMessage("El campo solo acepta letras y números.", (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          return index.int_number == "" ? true : (new RegExp('^[0-9a-zA-Z]+$')).test(index.int_number)
        })
      },
      postal_code: {
        required:helpers.withMessage("El campo es requerido.", requiredIf(function(){
          return (laborInformation.value.work.workStatus)? true: false;
        })),
        minLength: helpers.withMessage("El campo debe contener mínimo 5 caracteres", minLength(5)),
        maxLength: helpers.withMessage("El campo debe contener máximo 5 caracteres", maxLength(5)),
        onlyNumber: helpers.withMessage("El campo solo acepta números.", (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          if(index.postal_code.length != 5){
            addressRef.value.addressModel.suburb = ""
          }
          return (new RegExp('^[0-9]+$')).test(index.postal_code)
        })
      },
      between_street_one: {
        required:helpers.withMessage("El campo es requerido.",requiredIf(function(){
          return (laborInformation.value.work.workStatus)? true: false;
        })),
        minLength: helpers.withMessage("El campo debe contener mínimo 2 caracteres", minLength(2)),
        maxLength: helpers.withMessage("El campo debe contener máximo 100 caracteres", maxLength(100)),
        isAlphaNumeric:helpers.withMessage(`El campo no admite caracteres especiales.`,(data,index)=>index.street != ""? !new RegExp(/[^0-9a-zA-ZÀ-ÿ\s-#]+/).test(index.between_street_one): true),
        we_have_space_white_start_and_finish:helpers.withMessage(`El campo no puede tener espacios en blanco al inicio y al final.`,(data,index)=>index.between_street_one != ""? !new RegExp(/^([\s]{1,})|[-!$%^&*()_+|~=`{}[]:";'<>?,.\/]|([\s]{1,})$/).test(index.between_street_one): true),
        street_one_and_street_two_equal: helpers.withMessage(`El valor de: "Entre Calle" y el valor: "Y Calle" no pueden ser iguales`, (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          return index.between_street_one != index.between_street_two
        })
      },
      between_street_two:{
        required:helpers.withMessage("El campo es requerido.",requiredIf(function(){
          return (laborInformation.value.work.workStatus)? true: false;
        })),
        minLength: helpers.withMessage("El campo debe contener mínimo 2 caracteres", minLength(2)),
        maxLength: helpers.withMessage("El campo debe contener máximo 100 caracteres", maxLength(100)),
        isAlphaNumeric:helpers.withMessage(`El campo no admite caracteres especiales.`,(data,index)=>index.between_street_two != ""? !new RegExp(/[^0-9a-zA-ZÀ-ÿ\s-#]+/).test(index.between_street_two): true),
        we_have_space_white_start_and_finish:helpers.withMessage(`El campo no puede tener espacios en blanco al inicio y al final.`,(data,index)=>index.between_street_two != ""? !new RegExp(/^([\s]{1,})|[-!$%^&*()_+|~=`{}[]:";'<>?,.\/]|([\s]{1,})$/).test(index.between_street_two): true),
        street_one_and_street_two_equal: helpers.withMessage(`El valor de: "Entre Calle" y el valor: "Y Calle" no pueden ser iguales`, (data,index)=> {
          if(laborInformation.value.work.workStatus == null || laborInformation.value.work.workStatus == false){
            return true;
          }
          return index.between_street_one != index.between_street_two
        })
      }
    };

    const header = {
      headers: {
        "Content-Type": "application/json",
        "business": props.business
      },
    };

    watch(
      () => laborInformation.value.work.workCenter.workCenter,
      (value) => {
        laborInformation.value.work.workCenter.workCenterName = "";
        form_visibility.value.workplace_name_working = value == 'OTRO';
      }
    );

    watch( () => laborInformation.value.work.workCenter.unionSection, (value) => {
      laborInformation.value.work.workCenter.additional_data = "";
      if(laborInformation.value.work.workStatus && laborInformation.value.work.typeOfWork == "Trabajador de la educacion" && value == "seccion 2 FOBEN") {
        form_visibility.value.additional_data = true;
        dependecies.value = [
          { value:"I", name:"I Preescolar, primaria, niveles especiales, secundaria, UPN, Normales" },
          { value:"S", name:"S Lázaro Cárdenas, Tecnológico, SEIT(CBTIS, SESITIS, CBTA, BRIGADAS), CECATIS, Representación SEP" }
        ];
        return;
      }

      if(laborInformation.value.work.workCenter.businessLine.toUpperCase() == "EDUCACION" && laborInformation.value.work.workStatus == false && value == "seccion 2 FOBEN") {
        dependecies.value = [
          { value:"D",id:"d_dependencie", name:"D Jubilados homologados Centralizados" },
          { value:"J",id:"j_dependencie", name:"J Jubilados ISEP" }
        ];
        
        form_visibility.value.additional_data = true;
        return;
      } else {
        form_visibility.value.additional_data = false;
      }
    });

    function showActiveOptions() {
      if (
        props.active_job_type_options[
          "button_employee_status_working_information"
        ]
      ) {
        buttonsWorkType.value.push({
          id: "button_employee_status_working_information",
          value: "Empleado",
          text: "Empleado",
        });
      }

      if (
        props.active_job_type_options[
          "button_own_businesss_working_information"
        ]
      ) {
        buttonsWorkType.value.push({
          id: "button_own_businesss_working_information",
          value: "Negocio Propio",
          text: "Negocio propio",
        });
      }

      if (
        props.active_job_type_options[
          "button_education_worker_working_information"
        ]
      ) {
        buttonsWorkType.value.push({
          id: "button_education_worker_working_information",
          value: "Trabajador de la educacion",
          text: "Trabajador de la Educación",
        });
      }

      if (
        props.active_job_type_options[
          "button_health_worker_working_information"
        ]
      ) {
        buttonsWorkType.value.push({
          id: "button_health_worker_working_information",
          value: "Trabajador de la salud",
          text: "Trabajador de la Salud",
        });
      }

      if (props.active_job_status["button_active_status_working_information"]) {
        buttonsWorkStatus.value.push({
          id: "button_active_status_working_information",
          value: true,
          text: "Activo",
        });

        laborInformation.value.work.workStatus = true;
      }

      if (
        props.active_job_status["button_retired_status_working_information"]
      ) {
        buttonsWorkStatus.value.push({
          id: "button_retired_status_working_information",
          value: false,
          text: "Jubilado",
        });
      }

      if (
        props.active_job_status["button_student_status_working_information"]
      ) {
        buttonsWorkStatus.value.push({
          id: "button_student_status_working_information",
          value: null,
          text: "Estudiante",
        });
      }
    }

    const buttonsWorkStatus = ref([]);

    const buttonsPublicCharge = ref([
      {
        id: "radiobutton_public_office_yes_owner",
        value: true,
        text: "Sí",
      },
      {
        id: "radiobutton_public_office_no_owner",
        value: false,
        text: "No",
      },
    ]);

    const buttonsWorkType = ref([]);

    const buttonsFamilyPublicCharge = ref([
      {
        id: "radiobutton_public_office_yes_family",
        value: true,
        text: "Sí",
      },
      {
        id: "radiobutton_public_office_no_family",
        value: false,
        text: "No",
      },
    ]);

    const form_visibility = ref({
      business_rotation: true,
      type_work: true,
      work_place: true,
      business_name: false,
      union_section: false,
      workplace_working: false,
      workplace_name_working: false,
      address: false,
      retired: false,
      publicCharge: false,
      publicChargeFamily: false,
      contact: false,
      additional_data:false
    });

    function changeLaboralStatus(status = true) {
      laborInformationModelValidation.value.$reset();
      if (status == false) {
        set_window_by_type_of_work("pension");
        laborInformation.value.work.workStatus = false;
        laborInformation.value.work.typeOfWork = "";
        return;
      }

      if (status == null) {
        set_window_by_type_of_work("Estudiante");
        laborInformation.value.work.workStatus = null;
        laborInformation.value.work.typeOfWork = "";
        return;
      }

      if (
        !props.active_job_type_options[
          "button_employee_status_working_information"
        ] &&
        props.active_job_type_options[
          "button_health_worker_working_information"
        ]
      ) {
        set_window_by_type_of_work("Trabajador de la salud");
        laborInformation.value.work.typeOfWork = "Trabajador de la salud";
        return;
      }

      set_window_by_type_of_work("Empleado");
      laborInformation.value.work.workStatus = true;
      laborInformation.value.work.typeOfWork = "Empleado";
      if(workOfTypeRef.value){
        workOfTypeRef.value.buttonSelected = laborInformation.value.work.typeOfWork;
      }
    }

    function changeWorkType(type) {
      laborInformation.value.work.typeOfWork = type;
      set_window_by_type_of_work(type);
    }

    function changePublicCharge(status) {
      form_visibility.value.publicCharge = status;

      clear_form_public_charge(status);
      laborInformation.value.publicCharge.questionOne = status;
    }

    function changeFamilyPublicCharge(status) {
      form_visibility.value.publicChargeFamily = status;

      clear_form_family_public_charge(status);
      laborInformation.value.publicChargeFamily.questionOne = status;
    }

    function clear_form_public_charge(status) {
      if(!status){
        laborInformation.value.publicCharge.questionOne = "";
        laborInformation.value.publicCharge.questionTwo = "";
        laborInformation.value.publicCharge.startDate = "";
        laborInformation.value.publicCharge.endDate = "";
      }
    }

    function clear_form_family_public_charge(status) {
      if(!status){
        laborInformation.value.publicChargeFamily.questionOne = "";
        laborInformation.value.publicChargeFamily.questionTwo = "";
        laborInformation.value.publicChargeFamily.startDate = "";
        laborInformation.value.publicChargeFamily.endDate = "";
      }
    }

    function clear_form_telephone() {
      //telephone
      laborInformation.value.telephone.number = "";
      laborInformation.value.telephone.lada = "";
    }

    function select_date(value, node_name, sub_node_name) {
      laborInformation.value[node_name][sub_node_name] = moment(
        value._d
      ).format("DD-MM-YYYY");
    }

    async function get_catalog_business_activities() {
      isLoading.value = true;
      const resource = `/foncabsa/business_activities/index?token_auth=${sessionStorage.getItem(
        `${props.key_toke_storage}`
      )}`;
      const API_URL = `${props.urlAPI}${resource}`;

      axios
        .get(API_URL, header)
        .then((response) => {
          if (response.status != 200) {
            listBusinessActivities.value = [];
            alert("Ocurrio un error inesperado");
            return false;
          }

          const list_of_business_activities =
            response.data.response.data.filter(
              (activity) => activity.status === "activo"
            );
          listBusinessActivities.value = list_of_business_activities;
          laborInformation.value.work.workCenter.businessLine = props.selectBusinessWorkInfo.default_value;
          isLoading.value = false;
        })
        .catch((error) => {
          console.log(" Component Address ::", error);
          listBusinessActivities.value = [];
          isLoading.value = false;
        });
    }

    function get_affiliated_business() {
      isLoading.value = true;
      const resource = `/foncabsa/get_list_affiliated_business?token_auth=${sessionStorage.getItem(
        `${props.key_toke_storage}`
      )}`;
      const API_URL = `${props.urlAPI}${resource}`;

      axios
        .get(API_URL, header)
        .then((response) => {
          if (response.status != 200) {
            listAffiliatedBusiness.value = [];
            alert("Ocurrio un error inesperado");
            return false;
          }

          listAffiliatedBusiness.value =
            response.data.response.list_affiliated_business;
          isLoading.value = false;
        })
        .catch((error) => {
          console.log(" Error axios WorkingInformation affiliated_business :: ", error);
          listAffiliatedBusiness.value = [];
          isLoading.value = false;
        });
    }

    function get_catalog_union_sections() {
      isLoading.value = true;
      const resource = `/foncabsa/union_sections/index?token_auth=${sessionStorage.getItem(
        `${props.key_toke_storage}`
      )}`;
      const API_URL = `${props.urlAPI}${resource}`;

      axios
        .get(API_URL, header)
        .then((response) => {
          if (response.status != 200) {
            listUnionSections.value = [];
            alert("Ocurrio un error inesperado");
            return false;
          }

          listUnionSections.value = response.data.response.data;
        })
        .catch((error) => {
          console.log(" Error axios WorkingInformation :: ", error);
          listUnionSections.value = [];
          isLoading.value = false;
        });
    }

    function set_window_by_type_of_work(type) {
      reset_form_visibility();
      switch (type) {
        case "Empleado":
          show_form_employee();
          clear_form_work();
          break;
        case "Negocio Propio":
          show_form_own_business();
          clear_form_work();
          break;
        case "Trabajador de la educacion":
          showFormEducationWorker();
          clear_form_work();
          break;
        case "Estudiante":
          show_form_student();
          break;
        case "Trabajador de la salud":
          show_form_healt_worker();
          clear_form_work();
          //clear_form_public_charge();
          //clear_form_family_public_charge();
          clear_form_telephone();
          break;
        case "pension":
          show_form_pension();
          clear_form_work();
          //clear_form_public_charge();
          //clear_form_family_public_charge();
          clear_form_telephone();
          break;
      }
    }

    function reset_form_visibility() {
      form_visibility.value.business_rotation = false;
      form_visibility.value.type_work = false;
      form_visibility.value.work_place = false;
      form_visibility.value.business_name = false;
      form_visibility.value.union_section = false;
      form_visibility.value.workplace_working = false;
      form_visibility.value.workplace_name_working = false;
      form_visibility.value.address = false;
      form_visibility.value.retired = false;
      form_visibility.value.publicCharge = false;
      form_visibility.value.publicChargeFamily = false;
      form_visibility.value.contact = false;
      form_visibility.value.additional_data = false;
    }

    function show_form_employee() {
      form_visibility.value.business_rotation = true;
      form_visibility.value.type_work = true;
      form_visibility.value.work_place = props.props_form_visibility.work_place;
      form_visibility.value.address = true;
      form_visibility.value.contact = true;
    }

    function show_form_own_business() {
      form_visibility.value.business_rotation = true;
      form_visibility.value.type_work = true;
      form_visibility.value.address = true;
      form_visibility.value.business_name = true;
      form_visibility.value.contact = true;

    }

    function showFormEducationWorker() {
      form_visibility.value.union_section = true;
      form_visibility.value.type_work = true;
      form_visibility.value.address = true;
      form_visibility.value.workplace_working = true;
      form_visibility.value.contact = true;

    }

    function show_form_pension() {
      // Mostrar inputs de formulario de jubilado
      form_visibility.value.retired = true;
      form_visibility.value.business_rotation = true;

      form_visibility.value.union_section = false;
      if(laborInformation.value.work.workCenter.businessLine.toUpperCase() == "EDUCACION" && laborInformation.value.work.workStatus == false){
        form_visibility.value.union_section = true;
      }
    }

    function show_form_healt_worker() {
      // Mostrar inputs de formulario de trabajador de la salud
      form_visibility.value.type_work = true;
      form_visibility.value.address = true;
      form_visibility.value.business_rotation = true;
      form_visibility.value.publicCharge = false;
      form_visibility.value.publicChargeFamily = false;
      form_visibility.value.contact = true;

    }

    function show_form_student() {
      form_visibility.value.retired = true;
    }

    function clear_form_work() {
      //work
      laborInformation.value.work.workName = "";
      laborInformation.value.work.freeWorkCenterName = "";
      laborInformation.value.work.workCenter.additional_data = ""

      if(props.selectBusinessWorkInfo.default_value == ""){
        laborInformation.value.work.workCenter.businessLine = "";
      }

      laborInformation.value.work.workCenter.workCenter = "";
      laborInformation.value.work.workCenter.workCenterName = "";
      laborInformation.value.work.workCenter.unionSection = "";
    }

    function execute_validation() {
      let addressRefs = addressRef.value.execute_validation();
      laborInformationModelValidation.value.$validate();
      if (laborInformationModelValidation.value.$error || !addressRefs) {
        return false;
      }

      return {
        work_info: laborInformation.value,
        work_address_info: addressRefs
      };
    }

    return {
      isLoading,
      buttonsWorkStatus,
      buttonsWorkType,
      buttonsPublicCharge,
      buttonsFamilyPublicCharge,
      listBusinessActivities,
      listAffiliatedBusiness,
      listUnionSections,
      laborInformation,
      form_visibility,
      laborInformationModelValidation,
      changeLaboralStatus,
      changeWorkType,
      changePublicCharge,
      changeFamilyPublicCharge,
      execute_validation,
      select_date,
      viewClassViewAddress,
      addressRef,
      workOfTypeRef,
      rulesValidationsAddress,
      show_form_pension,
      dependecies,
      refPublicCharge,
      refFamilyPublicCharge,
      refWorkStatus
    };
  },
};
</script>

<style>
.vpd-input-group input {
  border: 2px solid rgba(205, 205, 205, 0.416) !important;
  border-start-end-radius: 10px;
  border-end-end-radius: 10px;
  padding: 5px !important;
  box-shadow: 0px 5px 10px 0px rgba(205, 205, 205, 0.416) !important;
}
</style>
